import React, {Component} from "react";


class Footer extends Component{
    render(){
        return(
        <footer class="footer">
            <p>Some footer nonsense!</p>
        </footer>
        )
    }
}

export default Footer;